// https://celoscan.io/address/0x50F4dAA86F3c747ce15C3C38bD0383200B61d6Dd
export const CROSS_CHAIN_CONTROLLER = '0x50F4dAA86F3c747ce15C3C38bD0383200B61d6Dd';

// https://celoscan.io/address/0x91b21900E91CD302EBeD05E45D8f270ddAED944d
export const CL_EMERGENCY_ORACLE = '0x91b21900E91CD302EBeD05E45D8f270ddAED944d';

// IPayloadsControllerCore https://celoscan.io/address/0xE48E10834C04E394A04BF22a565D063D40b9FA42
export const PAYLOADS_CONTROLLER = '0xE48E10834C04E394A04BF22a565D063D40b9FA42';

// https://celoscan.io/address/0x8657Cd5a0957e8C5BE15c69C67078b5d730D720a
export const PC_DATA_HELPER = '0x8657Cd5a0957e8C5BE15c69C67078b5d730D720a';

// https://celoscan.io/address/0xbE815420A63A413BB8D508d8022C0FF150Ea7C39
export const GRANULAR_GUARDIAN = '0xbE815420A63A413BB8D508d8022C0FF150Ea7C39';

// https://celoscan.io/address/0x056E4C4E80D1D14a637ccbD0412CDAAEc5B51F4E
export const GOVERNANCE_GUARDIAN = '0x056E4C4E80D1D14a637ccbD0412CDAAEc5B51F4E';

// https://celoscan.io/address/0x1dF462e2712496373A347f8ad10802a5E95f053D
export const EXECUTOR_LVL_1 = '0x1dF462e2712496373A347f8ad10802a5E95f053D';

export const CHAIN_ID = 42220;
